module.exports = __webpack_public_path__ + "static/media/hurricane.18059cc9.svg";